<template>
    <div class="container mescroll-touch">
        <div class="pos">
            <img src="../../assets/images/timelinetop.png" class="img" />
        </div>
        <div class="meetinginfo">
            <div class="infoitem">
                <img src="../../assets/images/meetingtime.png" class="meetingicon" />
                <div class="meetingtext">{{ list.DateStr }}</div>
            </div>
            <div class="infoitem1">
                <img src="../../assets/images/meetingziplace.png" class="meetingicon" />
                <div class="meetingtext">{{ list.Address }}</div>
            </div>
        </div>
        <div class="titlemain">
            <!-- <img src="../../assets/images/b.png" class="titleborder" /> -->
            <div class="titletext">{{ title }}</div>
        </div>
        <div class="listmain">
            <div class="listitem" v-for="(item, index) in list.Detail" :key="index">
                <div class="itempoint">
                    <img v-if="item.IsImportant" src="../../assets/images/type2icon.png" class="pointimg" />
                    <img v-else src="../../assets/images/type1icon.png" class="pointimg" />
                </div>
                <div class="time" :class="item.IsImportant ? 'textimp' : ''">{{ item.StartTimeStr }} - {{
                    item.EndTimeStr
                }}</div>
                <div class="title" :class="item.IsImportant ? 'textimp' : ''">{{ item.Title }}</div>
                <div class="jb" v-if="item.hasjb">
                    <div>发言嘉宾：</div>
                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 1" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 1" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 1" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
                <div class="zcr" v-if="item.haszcr">
                    <div>主持人：</div>
                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 2" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 2" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 2" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
                <div class="jz" v-if="item.hasjz">
                    <div style="display: flex; flex-direction: row;">
                        <div class="jzjz">讲</div>
                        <div>者：</div>
                    </div>

                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 3" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 3" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 3" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'timeline',
    data() {
        return {
            list: [],
            title: this.$route.query.title,
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
        // this.title = this.$route.query.title
        this.getdate()
    },
    methods: {
        getdate() {
            let that = this;
            this.$axios.get('/api/api/web/activity/GetSceduleDetail?id=' + this.$route.query.Id).then(res => {
                that.list = res.Data;
                console.log(res.Data.Detail)
                for (var d = 0; d < that.list.Detail.length; d++) {
                    that.list.Detail[d].hasjb = false;
                    that.list.Detail[d].haszcr = false;
                    that.list.Detail[d].hasjz = false;
                    for (var i = 0; i < that.list.Detail[d].Talker.length; i++) {
                        // console.log(res.Data.Detail[d].Talker[i].TalkerType)
                        let dtext = that.list.Detail[d].Talker[i]
                        if (dtext.TalkerType == 1) {
                            that.list.Detail[d].hasjb = true
                        }
                        if (dtext.TalkerType == 2) {
                            that.list.Detail[d].haszcr = true
                        }
                        if (dtext.TalkerType == 3) {
                            that.list.Detail[d].hasjz = true
                        }
                        console.log(this.list)
                    }
                }

            })
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
    // background: rgb(227, 235, 253);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.pos {
    position: relative;
}

.meetinginfo {
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    // top: 20%;
    display: flex;
    flex-direction: column;
    width: 95%;
    justify-content: center;
    margin: auto;
    font-weight: bold;
}

.meetingicon {
    width: 6%;
    height: .6rem;
    // margin-top: .05rem;
}

.infoitem {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.infoitem1 {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: .2rem;
}

.meetingtext {
    // color: #fff;
    margin-left: .2rem;
    color: rgb(0, 53, 133);
}

.titlemain {
    width: 90%;
    margin: 0.6rem auto;
    position: relative;
    margin-top: 0.3rem;
}

.titleborder {
    display: block;
    width: 100%;
}

.titletext {
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    // color: #6E56FB;
    // font-weight: bold;
    // font-size: .45rem;
    // width: 90%;
    // text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .47rem;
    width: 90%;
    margin: auto;
    text-align: center;
}

.listmain {
    width: 90%;
    margin: auto;
    margin-bottom: 0.6rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
    border-left: 1px solid rgb(0, 53, 133);
}

.time {
    color: rgb(0, 53, 133)
}

.title {
    color: rgb(0, 53, 133);
    margin: 0.1rem 0;
}

.textimp {
    font-weight: bold;
}

.listitem {
    border-bottom: 0.026667rem solid rgb(0, 53, 133);
    box-sizing: border-box;
    padding: 0.2rem 0;
    position: relative;
    padding-top: 0;
    margin-bottom: 0.3rem;
}

.zcr {
    // display: flex;
    // flex-direction: row;
    font-size: .35rem;
}

.jz {
    // display: flex;
    // flex-direction: row;
    font-size: .35rem;
}

.jb {
    font-size: .35rem;
}

.itempoint {
    position: absolute;
    width: 4%;
    left: -0.68rem;
    background: #fff;
}

.pointimg {
    display: block;
    width: 100%;
}

.jzjz {
    letter-spacing: .35rem;
}

.jobrow {
    display: flex;
    flex-direction: row;
    align-items: baseline;
}

.jobcenter {
    margin: 0 .2rem;
}

.zijv::first-letter {
    letter-spacing: .35rem;
}

.hosp {
    font-size: .3rem;
    max-width: 5rem;
}
</style>